import { Component, Input, OnInit } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup } from "@angular/forms";
import { isArray } from "util";
import { DropdownField } from "../models/field-dropdown";

@Component({
  selector: "sd-form-field-dropdown",
  templateUrl: "./sd-form-field-dropdown.component.html",
  styleUrls: ["./sd-form-field-dropdown.component.css"],
})
export class SdFormFieldDropdownComponent implements OnInit {
  @Input() formField: DropdownField;
  @Input() control: UntypedFormControl;
  @Input() formGroup: UntypedFormGroup;
  private values: Array<any>;

  ngOnInit() {
    console.log(this.formField.key, this.formField.label, this.formField.options)

    this.formField.options &&
      this.formField.options.subscribe((values) => {
        this.values = values;
        if (!this.control.value) {
          this.control.reset();
        }
      });

    //this.control.valueChanges.subscribe(value=>{
    // console.log(this.formField.key, value);
    //});
  }

  ngOnDestroy() { }

  onSelectionChanged(event: any) {
    if (this.formField.callback) {
      // console.log(this.values);
      let valueObject: any;
      if (isArray(event.value)) {
        valueObject = event.value.map((v: number) =>
          this.values.find((x: any) => x.key === v)
        );
      } else {
        valueObject = this.values.find((x: any) => x.key === event.value);
      }
      this.formField.callback(
        event.value,
        this.formField,
        this.formGroup,
        valueObject
      );
    }
  }
}
